export default "__VITE_ASSET__D9ik544B__"